(ns hai.workspaces.teams.routes
  (:require
   [hai.ui.components :as c]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Teams 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/workspaces/teams" {:name :workspaces/teams
                         ::routing/window-title "Teams"
                         :view page}]])